import { render, staticRenderFns } from "./GroupCommunityServiceList.vue?vue&type=template&id=d62a69a4&scoped=true&"
import script from "./GroupCommunityServiceList.vue?vue&type=script&lang=js&"
export * from "./GroupCommunityServiceList.vue?vue&type=script&lang=js&"
import style0 from "./GroupCommunityServiceList.vue?vue&type=style&index=0&id=d62a69a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62a69a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
